<script lang="ts" setup>
const SKELETON_STATUS_COUNT = 4;
const SKELETON_FINANCE_ROWS = 4;
const SKELETON_DATE_ROWS = 3;
</script>

<template>
  <div class="card skeleton-card">
    <div class="card-header skeleton-header">
      <div class="skeleton-line skeleton-title" />
    </div>
    <div class="card-content meta-content">
      <div class="status-group">
        <div
          v-for="i in SKELETON_STATUS_COUNT"
          :key="i"
          class="status-item skeleton-status-item"
        >
          <div class="skeleton-circle" />
          <div class="skeleton-text-stack">
            <div class="skeleton-line skeleton-label" />
            <div class="skeleton-line skeleton-value" />
          </div>
        </div>
      </div>

      <hr class="my-4" />

      <div class="columns is-align-items-stretch">
        <div class="column is-one-third">
          <div class="finance-group skeleton-finance">
            <div class="skeleton-line skeleton-group-header" />
            <div
              v-for="i in SKELETON_FINANCE_ROWS"
              :key="i"
              class="skeleton-meta-field"
            >
              <div class="skeleton-circle skeleton-icon" />
              <div class="skeleton-text-stack">
                <div class="skeleton-line skeleton-label" />
                <div class="skeleton-line skeleton-value" />
              </div>
            </div>
          </div>
        </div>

        <div class="column dates-column">
          <div
            v-for="group in 2"
            :key="group"
            class="date-group date-group-stretch skeleton-date-group"
          >
            <div class="skeleton-line skeleton-group-header" />
            <div class="date-row">
              <div
                v-for="i in SKELETON_DATE_ROWS"
                :key="i"
                class="skeleton-meta-field"
              >
                <div class="skeleton-circle skeleton-icon" />
                <div class="skeleton-text-stack">
                  <div class="skeleton-line skeleton-label" />
                  <div class="skeleton-line skeleton-date-value" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@keyframes shimmer {
  0% {
    background-position: -400px 0;
  }
  100% {
    background-position: 400px 0;
  }
}

.skeleton-card .card-header {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.skeleton-header {
  padding: 0.75rem 1rem;
  align-items: center;
}

.skeleton-line {
  border-radius: 4px;
  background: linear-gradient(90deg, #ebebeb 25%, #f5f5f5 50%, #ebebeb 75%);
  background-size: 800px 100%;
  animation: shimmer 1.4s infinite linear;
}

.skeleton-circle {
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: linear-gradient(90deg, #ebebeb 25%, #f5f5f5 50%, #ebebeb 75%);
  background-size: 800px 100%;
  animation: shimmer 1.4s infinite linear;
}

.skeleton-title {
  height: 1rem;
  width: 14rem;
  margin: 0.25rem 0;
}

.skeleton-label {
  height: 0.6rem;
  width: 4rem;
  margin-bottom: 0.3rem;
}

.skeleton-value {
  height: 0.85rem;
  width: 6rem;
}

.skeleton-date-value {
  height: 0.85rem;
  width: 5rem;
}

.skeleton-group-header {
  height: 0.6rem;
  width: 5rem;
  margin-bottom: 1rem;
}

.skeleton-status-item {
  display: flex;
  align-items: center;
  flex: 1;
  gap: 0.5rem;
  padding: 1rem 1rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #fff;
  min-width: 8rem;
}

.skeleton-text-stack {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1;
}

.skeleton-meta-field {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex: 1;
  padding: 0.3rem 0;
}

.skeleton-icon {
  width: 2rem;
  height: 2rem;
}

.skeleton-finance {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  padding: 1.2rem 1.25rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #fff;
  height: 100%;
}

.skeleton-date-group {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

/* Layout rules normally provided by ProjectMetaData.vue scoped styles */
.status-group {
  display: flex;
  align-items: stretch;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.status-item {
  flex: 1;
}

.dates-column {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.date-group {
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
  padding: 1.2rem 1.25rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #fff;
}

.date-group-stretch {
  flex: 1;
}

.date-row {
  display: flex;
  gap: 1rem;
}

.date-row > .skeleton-meta-field {
  flex: 1;
  min-width: 0;
}

.meta-content {
  background-color: #fafafc;
}

.meta-content hr {
  background-color: #c4c4cc;
}
</style>
